import React, { useRef, useState } from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useFormContext } from 'react-hook-form'
import { PGA_COM_HOST } from 'env'
import FileCopyOutlinedIcon from 'components/material-symbol/icons/FileCopy'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import TipWell, { TipWellActionButton } from 'components/tip-well'
import FormSubheader from '../form-subheader'
import { useCreateProfileFieldStyles } from '../field-styles'

const EditWebAddressSection = ({ customSlug }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const { register } = useFormContext()
  const [copySuccessMessage, setCopySuccessMessage] = useState('')
  const clipboardInputRef = useRef(null)
  const profileUrl = `${PGA_COM_HOST}/coach/${customSlug}`

  const copyToClipboard = event => {
    clipboardInputRef.current.type = 'text'
    clipboardInputRef.current.select()
    document.execCommand('copy')
    clipboardInputRef.current.type = 'hidden'
    event.target.focus()
    setCopySuccessMessage('Copied!')
  }

  return (
    <Box className={fieldClasses.fieldSection}>
      <FormSubheader
        title="Profile URL"
        description="Copy your public PGA.com link to share with students."
      />
      <input ref={register()} name="customSlug" type="hidden" />
      <input
        ref={clipboardInputRef}
        type="hidden"
        value={profileUrl}
        readOnly
      />
      <Box
        component="button"
        type="button"
        onClick={copyToClipboard}
        className={fieldClasses.fieldInput}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          padding: '12px 16px',
          border: '1px solid #D5DDE3',
          borderRadius: 8,
          backgroundColor: '#fff',
          cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <Typography
          component="span"
          style={{
            fontSize: '0.9375rem',
            color: '#00205B',
            wordBreak: 'break-all',
          }}
        >
          {profileUrl}
        </Typography>
        <FileCopyOutlinedIcon fontSize="small" aria-hidden />
      </Box>
      {copySuccessMessage ? (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginTop: 8 }}
        >
          {copySuccessMessage}
        </Typography>
      ) : null}
      <TipWell
        icon={InfoOutlinedIcon}
        caption="Your profile is live on PGA.com. Open your public page to preview what golfers see when they visit your listing."
        action={
          <TipWellActionButton
            component="a"
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Profile
          </TipWellActionButton>
        }
      />
    </Box>
  )
}

export default EditWebAddressSection
